import { getPagePermissionByPath } from './utils'

export const ADMIN_PERMISSION_SECTION = 'admin'
export const OPERATION_PERMISSION_SECTION = 'stock-management-operation'

export function filterPagesByModules(pages, moduleKeys) {
  if (!Array.isArray(pages) || !Array.isArray(moduleKeys) || moduleKeys.length === 0) return []
  return pages
    .map((page) => {
      const modules = Array.isArray(page?.modules) ? page.modules : []
      if (!moduleKeys.some((value) => modules.includes(value))) return null
      const next = { ...page }
      if (Array.isArray(page.subPage)) {
        next.subPage = filterPagesByModules(page.subPage, moduleKeys)
        if (next.pageType !== 'page' && next.subPage.length === 0) return null
      }
      return next
    })
    .filter(Boolean)
}

export function parseRestaurantPermissionPayload(data) {
  if (!data) return { permissionTrees: {}, restaurantAccess: [] }

  const permissionTrees = { ...(data.permissionsBySection || {}) }
  if (Array.isArray(data.availableSections)) {
    data.availableSections.forEach((sec) => {
      if (permissionTrees[sec]) return
      const key = `permissions${String(sec).charAt(0).toUpperCase()}${String(sec).slice(1)}`
      if (data[key]) permissionTrees[sec] = data[key]
    })
  }
  if (!permissionTrees[ADMIN_PERMISSION_SECTION] && data.permissionsAdmin) {
    permissionTrees[ADMIN_PERMISSION_SECTION] = data.permissionsAdmin
  }
  if (!permissionTrees[OPERATION_PERMISSION_SECTION] && data['permissionsStock-management-operation']) {
    permissionTrees[OPERATION_PERMISSION_SECTION] = data['permissionsStock-management-operation']
  }

  if (Array.isArray(data.restaurantAccess)) {
    return { permissionTrees, restaurantAccess: data.restaurantAccess }
  }

  return { permissionTrees, restaurantAccess: [] }
}

export function getRestaurantPermissions(permissionTrees, restaurantAccess, restaurantUuid, section) {
  const access = (restaurantAccess || []).find((row) => row.restaurantUuid === restaurantUuid)
  const tree = permissionTrees?.[section] || []
  return filterPagesByModules(tree, access?.moduleKeys || [])
}

export function getRestaurantPermissionsAllSections(permissionTrees, restaurantAccess, restaurantUuid) {
  const pages = []
  Object.keys(permissionTrees || {}).forEach((section) => {
    pages.push(...getRestaurantPermissions(permissionTrees, restaurantAccess, restaurantUuid, section))
  })
  return pages
}

export function restaurantHasPageByPath(permissionTrees, restaurantAccess, restaurantUuid, pathname, section = ADMIN_PERMISSION_SECTION) {
  const perms = getRestaurantPermissions(permissionTrees, restaurantAccess, restaurantUuid, section)
  return Boolean(getPagePermissionByPath(perms, pathname))
}

export function flagRestaurantsWithoutPage(restaurants, permissionTrees, restaurantAccess, pathname, section = ADMIN_PERMISSION_SECTION) {
  return (restaurants || []).map((rest) => ({
    ...rest,
    isDisabled: rest.uuid === 'all-restaurants'
      ? false
      : !restaurantHasPageByPath(permissionTrees, restaurantAccess, rest.uuid, pathname, section),
  }))
}
